import React from 'react';
import { Checkbox, Form, Button } from 'antd';
import { Link } from 'react-router-dom';
import withTranslations from 'app/components/HOGs/withTranslations';

const CheckLegalIssues = ({
  clickHandler = () => {},
  showLegalIssue = null,
  tr,
}) => {
  const text =
    tr[
      'I agree to all the Legal Issues and accept that I have read, understood and accepted these which can be read on this link'
    ];

  const validator = (rule, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Agree on the legal issues'));
  };

  return (
    <Form.Item
      style={{ marginTop: '-6px', width: '100%' }}
      valuePropName="checked"
      name="legalIssues"
      rules={[
        {
          validator,
        },
      ]}
    >
      <div className="legalIssues">
        <Checkbox>
          <div
            className="legalIssuesText"
            style={{ lineHeight: '18px', textAlign: 'justify', width: '100%' }}
          >
            {`${text}  `}
            <span onClick={clickHandler} aria-hidden>
              {showLegalIssue ? (
                <Button
                  style={{
                    fontSize: '12px',
                    lineHeight: '18px',
                    height: '18px',
                    padding: 0,
                  }}
                  onClick={showLegalIssue}
                  type="link"
                >
                  <span>{tr['Link to Legal Issues']}</span>
                </Button>
              ) : (
                <Link to="/legalissues">{tr['Link to Legal Issues']}</Link>
              )}
            </span>
          </div>
        </Checkbox>
      </div>
    </Form.Item>
  );
};

CheckLegalIssues.displayName = 'CheckLegalIssues';

export default withTranslations(CheckLegalIssues);
